var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"mb-5"},[_c('b-form-textarea',{attrs:{"id":"textarea","placeholder":"Enter something...","rows":"3","max-rows":"6"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('pre',{staticClass:"mt-3 mb-0"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"mb-4"},[_c('strong',[_vm._v("Default Usage")])])
}]

export { render, staticRenderFns }